import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, darken, IconButton, styled } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

import logoLandscape from "assets/logo-landscape.svg";
import TopBarMenu from "./TopBarMenu";

const Nav = styled("nav")(({ theme }) => {
  return {
    "&.TopBar-root": {
      position: "relative",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      padding: theme.spacing(1),
      boxShadow: "0 2px 4px #0004",
      zIndex: 1000,
      "& .MuiIconButton-root:hover": {
        backgroundColor: darken(theme.palette.primary.main, 0.2),
      },
    },
    "& .TopBar-header": {
      display: "grid",
      alignItems: "center",
      gridTemplateColumns: "1fr auto 1fr",
    },
    "& .TopBar-logo": {
      width: "5rem",
      display: "block",
      marginInline: "auto",
    },
  };
});

type TopBarProps = {
  onLogout: () => void;
};

const TopBar: React.FC<TopBarProps> = (props) => {
  const { onLogout } = props;

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Nav data-open={isMenuOpen} className="TopBar-root">
      <Box className="TopBar-header">
        <Box display="flex" justifyContent="flex-start">
          <IconButton onClick={() => setIsMenuOpen(!isMenuOpen)} color="inherit">
            {isMenuOpen ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
        </Box>

        <Box className="TopBar-logo" component="img" src={logoLandscape} alt="avs-logo" />

        <Box display="flex" justifyContent="flex-end">
          <IconButton component={RouterLink} to="/profile" color="inherit">
            <AccountCircleIcon />
          </IconButton>

          <IconButton color="inherit" onClick={() => onLogout()}>
            <LogoutIcon />
          </IconButton>
        </Box>
      </Box>

      {isMenuOpen && <TopBarMenu onClose={() => setIsMenuOpen(false)} />}
    </Nav>
  );
};

export default TopBar;
